import { useState } from "react";

import {
  App,
  Modal,
  Typography,
  Transfer,
  Flex,
  Form,
  Input,
  Button,
  Space,
  InputNumber,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import {
  createGroup,
  updateGroup,
  addFieldsFromGroup,
  deleteGroup,
} from "@/api/definitionGroups";

const { Text, Paragraph } = Typography;

const TransferFieldsModal = ({
  allFields = [],
  currentFields = [],
  visible,
  onSave,
  onCancel,
  group = null,
  defId,
  maxIdx = 1,
}) => {
  const [form] = Form.useForm();
  const mockData = [...allFields];
  const { message } = App.useApp();

  const [targetKeys, setTargetKeys] = useState(
    currentFields.map((item) => item.uuid)
  );
  const [selectedKeys, setSelectedKeys] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const onChange = (nextTargetKeys, direction, moveKeys) => {
    console.log("targetKeys:", nextTargetKeys);
    console.log("direction:", direction);
    console.log("moveKeys:", moveKeys);
    setTargetKeys(nextTargetKeys);
  };
  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    console.log("sourceSelectedKeys:", sourceSelectedKeys);
    console.log("targetSelectedKeys:", targetSelectedKeys);
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };
  const onScroll = (direction, e) => {
    console.log("direction:", direction);
    console.log("target:", e.target);
  };

  const handleCancel = () => {
    setError(null);
    onCancel();
  };
  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);
    let res;
    try {
      if (group.uuid) {
        res = await updateGroup({
          ...group,
          name: values.name,
          idx: values.idx,
        });
      } else {
        res = await createGroup({
          definition_uuid: defId,
          name: values.name,
          idx: values.idx,
        });
      }

      if (targetKeys.length) {
        await addFieldsFromGroup({
          group_uuid: res.uuid,
          fields_uuids: targetKeys,
        });
      }
      onSave();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  // Обработчик удаления группы
  const handleDeleteItem = async () => {
    try {
      await deleteGroup({ uuid: group.uuid });
      onSave();
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    }
  };

  return (
    <Modal
      maskClosable={false}
      title="Настройка полей"
      open={visible}
      onCancel={handleCancel}
      footer={
        <Flex align="center" justify="space-between">
          {group?.name && (
            <Typography.Link
              onClick={handleDeleteItem}
              style={{ color: "red" }}
            >
              <Space>
                <DeleteOutlined /> Удалить группу
              </Space>
            </Typography.Link>
          )}
          <Space style={{ marginLeft: "auto" }}>
            <Button key="cancel" loading={isLoading} onClick={handleCancel}>
              Отмена
            </Button>
            <Button
              key="submit"
              type="primary"
              loading={isLoading}
              onClick={onOk}
            >
              Сохранить
            </Button>
          </Space>
        </Flex>
      }
      zIndex={10000}
      width={590}
    >
      <Flex vertical>
        {group && (
          <Form
            form={form}
            layout="vertical"
            initialValues={{ name: group.name, idx: group.idx || maxIdx }}
          >
            <Flex gap={20}>
              <Form.Item name="idx" label="№ п/п">
                <InputNumber min={1} />
              </Form.Item>
              <Form.Item
                name="name"
                label="Название группы"
                rules={[
                  { required: group, message: "Пожалуйста, введите название" },
                ]}
                style={{ flex: 1 }}
              >
                <Input />
              </Form.Item>
            </Flex>
          </Form>
        )}

        <Text>Список полей</Text>
        <Paragraph type="secondary">
          Перенесите нужные поля в правый столбец
        </Paragraph>
        <Transfer
          dataSource={mockData}
          showSearch
          targetKeys={targetKeys}
          selectedKeys={selectedKeys}
          onChange={onChange}
          onSelectChange={onSelectChange}
          onScroll={onScroll}
          oneWay
          rowKey={(record) => record.uuid}
          render={(item) => item.name}
          listStyle={{
            width: 250,
            height: 400,
          }}
        />

        {error && <Text type="danger">{error}</Text>}
      </Flex>
    </Modal>
  );
};

export default TransferFieldsModal;
